import { RouteButton } from "../../Buttons"
import { GenericTableFactory } from "../../_Shared/Table/Classes/Factory"
/**
 *  ### Route for ('/tasks/')
 */
export function TaskList() {
    const table = GenericTableFactory.createTaskTable()
    
    return (
      <>
        <div className="pt-5 pl-5">
            <h1>Tasks</h1>
        </div>

        {table.RenderTable()}

        <div className="flex flex-row justify-center gap-3 m-2">
            <RouteButton route={"/main_menu"} text="Back"/>
        </div>
        </>
    )
}
  
